<template>
  <div class="df">
    <draggable
      class="df"
      v-model="menuList"
      @start="drag = true"
      @end="onDragEnd"
      item-key="index"
    >
      <template #item="{ element, index }">
        <div
          :class="`item df dragTitle ${index === checkIndex ? 'active' : ''}`"
          @click="() => checkMenuTab(index)"
        >
          <a-tooltip>
            <template #title>
              {{
                [null, '', undefined].includes(element.menuName)
                  ? '一级菜单名称'
                  : element.menuName
              }}
            </template>
            <span
              class="menuTit"
              :style="
                element.langs?.[0]?.menuPic
                  ? {
                      width: '160px',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      display: 'inline-block',
                      paddingLeft: '25px',
                      backgroundImage: `url(${element.langs?.[0]?.menuPic})`,
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center'
                    }
                  : {
                      width: '160px',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      display: 'inline-block',
                      paddingLeft: '25px'
                    }
              "
            >
              <lock-outlined v-if="element.raceLock" style="color: #ff0000;" />

              {{
                [null, '', undefined].includes(element.menuName)
                  ? '一级菜单名称'
                  : element.menuName
              }}
            </span>
          </a-tooltip>
          <span
            class="mr4 cp icon"
            @click="
              () => {
                checkMenuTab(index)
                dealMenu(true, 1, 2, element)
              }
            "
            ><edit-outlined
          /></span>
          <a-popconfirm
            title="是否确认删除?"
            ok-text="确认"
            cancel-text="取消"
            @confirm="() => removeMenu({ menuType: 1, index })"
          >
            <span class="cp icon"><close-outlined /></span>
          </a-popconfirm>
        </div>
      </template>
    </draggable>
    <div
      class="addTab"
      @click="
        () => {
          dealMenu(true, 1, 1)
        }
      "
    >
      <plus-outlined />
    </div>
  </div>
  <div
    class="dragContainer df"
    v-if="checkIndex !== null && menuList && menuList.length"
  >
    <div class=" w300">
      <draggable
        v-model="menuList[checkIndex].menuList"
        @start="drag = true"
        @end="onDragEnd"
        :move="e => checkMove(e, menuList[checkIndex].menuList)"
        handle=".menuTit"
        item-key="index"
      >
        <template #item="{ element, index }">
          <div
            :class="
              `item df dragTitle twoTitle ${
                index === sonCheckIndex ? 'active' : ''
              }`
            "
            v-if="element.menuModule === 1"
            @click="() => checkTwoMenuTab(index, element)"
          >
            <a-tooltip
              v-if="element.menuCategory === 1 && element.menuModule === 1"
            >
              <template #title>
                {{
                  [null, '', undefined].includes(element.menuName)
                    ? '二级菜单名称'
                    : element.menuName
                }}
              </template>
              <span
                class="menuTit"
                style="width:160px;overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: inline-block; padding-left: 25px;cursor: grab"
              >
                <img
                  class="twoMenu-img mr5"
                  v-if="element.langs?.[0]?.menuPic"
                  :src="element.langs?.[0]?.menuPic"
                  alt=""
                />
                <lock-outlined
                  v-if="element.raceLock"
                  style="color: #ff0000;"
                />

                {{
                  [null, ''].includes(element.menuName)
                    ? '二级菜单名称'
                    : element.menuName
                }}
              </span>
            </a-tooltip>
            <div v-if="element.menuCategory === 2">
              <img
                :src="element.langs?.[0]?.menuPicDtos?.[0]?.picUrl"
                style="width: 230px;height: 40px;"
                alt=""
              />
            </div>
            <span
              class="mr4 cp icon"
              @click="
                () => {
                  checkTwoMenuTab(index, element)
                  dealMenu(true, 2, 2, element)
                }
              "
              ><edit-outlined
            /></span>
            <span
              class="mr4 cp icon"
              @click="
                () => {
                  checkTwoMenuTab(index, element)
                  dealMenu(true, 2, 2, element)
                }
              "
              ><PictureOutlined
            /></span>
            <a-popconfirm
              title="是否确认删除?"
              ok-text="确认"
              cancel-text="取消"
              @confirm="() => removeMenu({ menuType: 2, sonIndex: index })"
            >
              <span class="cp icon"><close-outlined /></span>
            </a-popconfirm>
          </div>
        </template>
      </draggable>
      <div class="addPerMenu addTwoMenu " @click="() => dealMenu(true, 2, 1)">
        + 添加二级菜单
      </div>
      <a-divider dashed style="margin: 10px 0px;" />
      <!-- <div
        v-for="(policy, index) in menuList[checkIndex].menuList.filter(
          item => item.menuModule === 2
        )"
        :key="index"
      >
        <div
          :class="
            `item df dragTitle twoTitle ${
              index === sonCheckIndex ? 'active' : ''
            }`
          "
          @click="() => checkTwoMenuTab(index)"
        >
          <span
            class="menuTit"
            style="width:160px;overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: inline-block; padding-left: 25px;"
          >
            <img
              class="twoMenu-img mr5"
              v-if="policy.menuPic"
              :src="policy.menuPic"
              alt=""
            />
            <lock-outlined v-if="policy.raceLock" style="color: #ff0000;" />

            {{
              [null, ''].includes(policy.menuName)
                ? '二级菜单名称'
                : policy.menuName
            }}
          </span>
          <span class="mr4 cp icon" @click="() => dealMenu(true, 2, 2, policy)"
            ><edit-outlined
          /></span>
          <a-popconfirm
            title="是否确认删除?"
            ok-text="确认"
            cancel-text="取消"
            @confirm="() => removeMenu({ menuType: 2, sonIndex: index })"
          >
            <span class="cp icon"><close-outlined /></span>
          </a-popconfirm>
        </div>
      </div> -->
      <draggable
        v-model="menuList[checkIndex].menuList"
        @start="drag = true"
        @end="onDragEnd"
        handle=".menuTit"
        item-key="index"
      >
        <template #item="{ element, index }">
          <div
            :class="
              `item df dragTitle twoTitle ${
                index === sonCheckIndex ? 'active' : ''
              }`
            "
            v-if="element.menuModule === 2"
            @click="() => checkTwoMenuTab(index, element)"
          >
            <a-tooltip v-if="element.menuModule === 2">
              <template #title>
                {{
                  [null, '', undefined].includes(element.menuName)
                    ? '二级菜单名称'
                    : element.menuName
                }}
              </template>
              <span
                class="menuTit"
                style="width:160px;overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: inline-block; padding-left: 25px;cursor: grab"
              >
                <img
                  class="twoMenu-img mr5"
                  v-if="element.langs?.[0]?.menuPic"
                  :src="element.langs?.[0]?.menuPic"
                  alt=""
                />
                <lock-outlined
                  v-if="element.raceLock"
                  style="color: #ff0000;"
                />

                {{
                  [null, ''].includes(element.menuName)
                    ? '二级菜单名称'
                    : element.menuName
                }}
              </span>
            </a-tooltip>
            <span
              class="mr4 cp icon"
              @click="
                () => {
                  checkTwoMenuTab(index, element)
                  dealMenu(true, 2, 2, element)
                }
              "
              ><edit-outlined
            /></span>
            <span
              class="mr4 cp icon"
              @click="
                () => {
                  checkTwoMenuTab(index, element)
                  dealMenu(true, 2, 2, element)
                }
              "
              ><PictureOutlined
            /></span>
            <a-popconfirm
              title="是否确认删除?"
              ok-text="确认"
              cancel-text="取消"
              @confirm="() => removeMenu({ menuType: 2, sonIndex: index })"
            >
              <span class="cp icon"><close-outlined /></span>
            </a-popconfirm>
          </div>
        </template>
      </draggable>
      <a-button
        v-if="route.query.terminalId !== '2'"
        :disabled="
          menuList[checkIndex].menuList.filter(item => item.menuModule === 2)
            .length >= 6
        "
        class="addPerMenu addTwoMenu "
        style="line-height: 32px;"
        @click="() => dealMenu(true, 2, 1, undefined, 2)"
      >
        + 添加政策菜单
      </a-button>
    </div>
    <!-- 三级、四级 -->
    <div class="ml20 w500">
      <div
        v-if="
          menuList &&
            menuList[checkIndex].menuList[sonCheckIndex] &&
            menuList[checkIndex].menuList[sonCheckIndex].menuList &&
            menuList[checkIndex].menuList[sonCheckIndex].menuList.length
        "
      >
        <draggable
          class="threeMenu-wrapper"
          v-model="menuList[checkIndex].menuList[sonCheckIndex].menuList"
          @start="drag = true"
          @end="onDragEnd"
          item-key="index"
        >
          <template #item="{ element, index:gsIndex }">
            <div>
              <div class="threeMenu">
                <a-tooltip>
                  <template #title>
                    {{
                      [null, '', undefined].includes(element.menuName)
                        ? '三级菜单名称'
                        : element.menuName
                    }}
                  </template>
                  <span class="menuTit">
                    <lock-outlined
                      v-if="element.raceLock"
                      style="color: #ff0000;"
                    />

                    {{
                      [null, ''].includes(element.menuName)
                        ? '三级菜单名称'
                        : element.menuName
                    }}
                  </span>
                </a-tooltip>
                <span
                  class="mr4 cp icon"
                  @click="
                    () => {
                      checkTwoMenuTab(
                        sonCheckIndex,
                        menuList[checkIndex].menuList[sonCheckIndex]
                      )
                      gsCheckIndex = gsIndex
                      dealMenu(true, 3, 2, element)
                    }
                  "
                  ><edit-outlined
                /></span>
                <a-popconfirm
                  title="是否确认删除?"
                  ok-text="确认"
                  cancel-text="取消"
                  @confirm="() => removeMenu({ menuType: 3, gsIndex })"
                >
                  <span class="cp icon"><close-outlined /></span>
                </a-popconfirm>
              </div>
              <div
                class="fourMenu-wrapper"
                v-if="element.menuList && element.menuList.length"
              >
                <draggable
                  class="grid-wrapper"
                  :class="{
                    'grid-1': element.imgStyle === 0,
                    'grid-2': element.imgStyle === 1,
                    'grid-3': element.imgStyle === 2,
                    'grid-4': element.imgStyle === 3
                  }"
                  v-model="element.menuList"
                  @start="drag = true"
                  @end="onDragEnd"
                  item-key="index"
                >
                  <template #item="{ element:element2, index:fIndex }">
                    <div
                      class="fourMenu-content"
                      :style="
                        element2.langs?.[0]?.menuPic
                          ? {
                              backgroundImage: `url(${element2.langs?.[0]?.menuPic})`,
                              backgroundSize: 'cover',
                              backgroundPosition: 'center'
                            }
                          : {}
                      "
                    >
                      <div class="fourMenu-title">
                        <a-tooltip>
                          <template #title>
                            {{
                              [null, '', undefined].includes(element2.menuName)
                                ? '四级菜单名称'
                                : element2.menuName
                            }}
                          </template>
                          <span class="menuTit">
                            <lock-outlined
                              v-if="element2.raceLock"
                              style="color: #ff0000;"
                            />

                            {{
                              [null, ''].includes(element2.menuName)
                                ? '四级菜单名称'
                                : element2.menuName
                            }}
                          </span>
                        </a-tooltip>
                        <span
                          class="mr4 cp icon"
                          @click="
                            () => {
                              checkTwoMenuTab(
                                sonCheckIndex,
                                menuList[checkIndex].menuList[sonCheckIndex]
                              )
                              gsCheckIndex = gsIndex
                              fourIndex = fIndex
                              dealMenu(true, 4, 2, element2)
                            }
                          "
                          ><edit-outlined
                        /></span>
                        <a-popconfirm
                          title="是否确认删除?"
                          ok-text="确认"
                          cancel-text="取消"
                          @confirm="
                            () => removeMenu({ menuType: 4, gsIndex, fIndex })
                          "
                        >
                          <span class="cp icon"><close-outlined /></span>
                        </a-popconfirm>
                      </div>
                      <div class="fourMenu-img-wrapper"></div>
                    </div>
                  </template>
                </draggable>
              </div>
              <div
                class="addPerMenu addFourMenu"
                v-if="element.imgStyle === 3"
                :disabled="(element.menuList || []).length >= 5"
                @click="
                  () => {
                    if ((element.menuList || []).length >= 5) return
                    gsCheckIndex = gsIndex
                    dealMenu(true, 4, 1)
                  }
                "
              >
                + 添加四级菜单
              </div>
            </div>
          </template>
        </draggable>
      </div>
      <!-- {{ menuList[checkIndex].menuList }} -->
      <div
        v-if="menuList[checkIndex].menuList.length && showThreeTab"
        class="addPerMenu addThreeMenu"
        @click="() => dealMenu(true, 3, 1)"
      >
        + 添加三级菜单
      </div>
    </div>
  </div>
</template>

<script>
import { toRefs, inject, reactive } from 'vue'
import draggable from 'vuedraggable'
import { useRoute } from 'vue-router'
import { message } from '@ant-design/icons-vue'
import {
  PlusOutlined,
  EditOutlined,
  CloseOutlined,
  LockOutlined
} from '@ant-design/icons-vue'
export default {
  components: {
    LockOutlined,
    PlusOutlined,
    CloseOutlined,
    EditOutlined,
    draggable
  },
  setup() {
    const init = inject('initState')
    const route = useRoute()
    const state = reactive({
      drag: false,
      hasShownWarning: false // 拖拽结束时重置警告状态
    })
    const onDragEnd = () => {
      state.drag = false
      console.log('拖动结束')
      state.hasShownWarning = false
      init.postParams.modify = true
    }
    // const isEdgeElement = (index, list) => {
    //   return index === 0 || index === list.length - 1
    // }
    const checkMove = ({ draggedContext, relatedContext }, lists) => {
      const header = lists.filter(item => item.menuCategory === 2)
      if (!header?.length) {
        return true
      }
      const draggedElemnet = draggedContext.element
      const targetElemnt = relatedContext.element
      if (
        draggedElemnet.menuCategory === 2 ||
        targetElemnt.menuCategory === 2
      ) {
        if (!state.hasShownWarning) {
          message.error('禁止更改头尾导航位置')
        }
        state.hasShownWarning = true
        return false
      }
    }
    return {
      state,
      checkMove,
      route,
      ...toRefs(inject('initState')),
      onDragEnd
    }
  }
}
</script>

<style lang="scss" scoped>
.dragTitle {
  width: 200px;
  text-align: center;
  flex-shrink: 0;
  border: 1px solid #f0f0f0;
  background: #fafafa;
  line-height: 40px;
  margin-right: 4px;
  padding: 0 5px;
}

.addTab {
  width: 60px;
  height: 40px;
  font-size: 16px;
  text-align: center;
  flex-shrink: 0;
  border: 1px solid #f0f0f0;
  background: #fafafa;
  line-height: 40px;
  cursor: pointer;
}

.dragSon {
  height: 40px;
  text-align: center;
  flex-shrink: 0;
  border: 1px solid #f0f0f0;
  background: #ffffff;
  line-height: 40px;
  margin-bottom: 4px;
}

.addThreeLevel {
  height: 40px;
  text-align: center;
  flex-shrink: 0;
  border: 1px dashed #d9d9d9;
  background: #ffffff;
  line-height: 40px;
  margin-bottom: 4px;
}

.dragTitle.active {
  background: #ffffff;
  color: rgba(24, 144, 255, 1);
}

.dragList {
  width: 330px;
  padding: 10px;
  text-align: center;
  flex-shrink: 0;
  border: 1px solid #f0f0f0;
  background: #fafafa;
  line-height: 40px;
  margin-right: 10px;
}

.dragContainer {
  min-width: 1000px;
  min-height: 500px;
  background: #ffffff;
  border-top: 1px solid #f0f0f0;
  margin-top: -1px;
  padding: 10px;
}

input.disBg {
  background: transparent;
  border: none;
}

.icon {
  color: #cccccc;
}

.addPerMenu {
  width: 230px;
  height: 40px;
  text-align: center;
  flex-shrink: 0;
  border: 1px dashed #d9d9d9;
  background: #ffffff;
  line-height: 40px;
  margin-bottom: 4px;
  cursor: pointer;
}

.dragTitles {
  overflow-y: hidden;
  overflow-x: scroll;
}

.menuTit {
  flex: 1;
  display: inline-block;
  width: 160px;
  text-overflow: ellipsis;
  overflow: hidden;
  background: url('https://cdn-image.kapeixi.cn/web/58a793cf-e268-482c-977d-e5c23c0bb011/drag.png')
    0px center no-repeat;
  cursor: pointer;
}

.addPerMenu.footer {
  width: 200px;
}

.footerCOntainer {
  background: #fafafa;
  padding: 10px;
  margin: 10px;
}

.footerCOntainer .dragTitle {
  background: #ffffff;
}

.footerCOntainer .dragTitle.item {
  background: #fafafa;
  border-color: transparent;
}
.addFourLevel {
  width: 80%;
  height: 40px;
  text-align: center;
  flex-shrink: 0;
  border: 1px dashed #d9d9d9;
  background: #fafafa;
  line-height: 40px;
  margin-bottom: 4px;
  margin: 0 auto;
}
.addTab {
  width: 60px;
  height: 40px;
  font-size: 16px;
  text-align: center;
  flex-shrink: 0;
  border: 1px solid #f0f0f0;
  background: #fafafa;
  line-height: 40px;
  cursor: pointer;
}
.addTwoMenu {
  width: 300px;
  margin-top: 10px;
}
.addThreeMenu {
  width: 100%;
}
.addFourMenu {
  width: 90%;
  margin: 0 auto;
  margin-bottom: 10px;
}
.threeMenu-wrapper > div {
  background-color: #fafafa;
}

.twoTitle {
  width: 100%;
  align-items: center;
  text-align: unset;
  padding: 5px;
  margin-right: 0;
  margin-bottom: 5px;
}
.twoMenu-img {
  width: 44px;
  height: 44px;
}
.threeMenu {
  width: 100%;
  display: flex;
  margin-bottom: 10px;
  padding: 5px;
  .menuTit {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
    padding-left: 25px;
  }
}
.fourMenu-wrapper {
  width: 90%;
  margin: 0 auto;
}

.fourMenu-title {
  display: flex;
  padding: 4px;
  .menuTit {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
    padding-left: 25px;
  }
}

.grid-wrapper {
  display: grid;
  column-gap: 2%;
  row-gap: 10px;
  margin-bottom: 10px;
  .img-style {
    width: 100%;
  }
}
.grid-4 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}
.fourMenu-content {
  width: 100%;
  height: 60px;
  background-color: #f7f7f7;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
}
.fourMenu-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px;
  height: 24px;
  background: rgba(255, 255, 255, 0.85);
}
.fourMenu-img-wrapper {
  height: 36px;
}
.grid-1 {
  grid-template-columns: repeat(1, 100%);
}
.grid-2 {
  grid-template-columns: repeat(2, 49%);
}
.grid-3 {
  grid-template-columns: repeat(3, 32%);
}
.fourMenu-content {
  background-color: #fff;
}
</style>
